import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import MetaInfo from '@/components/common/MetaInfo'
import TransformBanner from '@sections/TransformBanner'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_USECASES_BUSINESS_APPLICATIION)


const RIGHT_AI_APPROACH = [
  { requirement: 'Generate answers from company documents', approach: 'Generative AI with retrieval and source grounding' },
  { requirement: 'Extract information from documents', approach: 'AI document processing and validation' },
  { requirement: 'Route requests to the right team', approach: 'Classification with workflow automation' },
  { requirement: 'Coordinate a sequence of permitted tasks', approach: 'Workflow orchestration and controlled AI agents' },
  { requirement: 'Forecast demand or workload', approach: 'Statistical forecasting or machine learning' },
{ requirement: 'Identify unusual patterns', approach: 'Anomaly detection' },
  { requirement: 'Recommend products or content', approach: 'Recommendation systems' },
  { requirement: 'Add AI features to an existing application', approach: 'AI integration using suitable APIs and application architecture' },
 
]
export default function AiUseCases() {
  

  return (<><MetaInfo
     title={label}  
    description={metaDesc}
   keywords=""
  />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
              <Breadcrumb />
             <h1>{label}</h1>
             <p className="page-subtitle">
            {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right">
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         
   <section className="section-py bg-linear-gradient-light " aria-labelledby="we-assess-heading">
      <div className="container">
        <p className='text-center'>Not every AI opportunity requires the same technology. The right approach depends on the task, the available data and the level of reliability and control required.</p>

        <div className="comparison-table" role="table" aria-label="Comparison of other providers versus us"  data-aos="fade-up">
          <div className="comparison-row comparison-row--head" role="row">
            <div className="comparison-cell comparison-cell--head comparison-cell--requirement" role="columnheader">
              Business requirement
            </div>
            <div className="comparison-cell comparison-cell--head comparison-cell--ours" role="columnheader">
              Potential approach
            </div>
          </div>

          {RIGHT_AI_APPROACH.map(row => (
            <div className="comparison-row" role="row" key={row.requirement}>
              <div className="comparison-cell comparison-cell--requirement" role="cell">
                <span>{row.requirement}</span>
              </div>
              <div className="comparison-cell comparison-cell--ours" role="cell">
                {row.approach}
              </div>
            </div>
          ))}
        </div>
        <p className='pt-4 text-center'>Sometimes conventional software rules, search technology or standard analytics are more appropriate than AI. A good solution uses AI where it provides a genuine advantage, rather than adding it simply because it is available.
</p>
      </div>
    </section>
         <TransformBanner />
         </main></>
  )
}